import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSuitcaseComponent } from "./med-icon-suitcase.component";

@NgModule({
  declarations: [
    MedIconSuitcaseComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSuitcaseComponent,
  ],
})
export class MedIconSuitcaseModule { }
